import { ASSETS_HOST } from "./assets";

/**
 * Generates the S3 URL for a project's preview image
 */
export function getProjectPreviewImageUrl({
  workspaceId,
  projectId,
  env,
  includeBaseUrl = true,
}: {
  workspaceId: string;
  projectId: string;
  env: string | undefined;
  includeBaseUrl?: boolean;
}): string {
  return `${includeBaseUrl ? `https://${ASSETS_HOST}/` : ""}project-preview-screenshots/${env ?? "dev"}/workspaces/${workspaceId}/projects/${projectId}/preview-desktop.jpeg`;
}
